import DialogUI from '@travel/traveler-core/components/Dialog';
import { cx } from '@travel/utils';

import styles from './dialog.module.scss';

import type { Props as DialogUIProps } from '@travel/traveler-core/components/Dialog';

const Dialog = (props: DialogUIProps) => {
  const {
    className,
    contentClassName,
    title,
    buttonLabelPrimary,
    buttonLabelSecondary,
    isRightCloseButton = true,
    actionClassName,
    ...rest
  } = props;

  const isNoButton = !buttonLabelPrimary && !buttonLabelSecondary;
  const isOneButton = !!buttonLabelPrimary !== !!buttonLabelSecondary;
  const hasTitle = title !== undefined && title !== null;

  return (
    <DialogUI
      className={cx(styles.dialog, styles.radiusTop, hasTitle ? styles.fullScreen : '', className)}
      contentClassName={cx(styles.content, contentClassName)}
      isUseContentFlexBox={false}
      headerClassName={cx(styles.header, styles.radiusTop, hasTitle ? styles.resetRadiusTop : '')}
      actionClassName={cx(
        styles.actionWrapper,
        styles.radiusBottom,
        actionClassName,
        hasTitle ? styles.resetRadiusBottom : '',
      )}
      closeButtonClassName={isRightCloseButton ? styles.headerButtonRight : styles.headerButton}
      titleClassName={cx(styles.title, isRightCloseButton ? styles.titleButtonRight : '')}
      title={title}
      containerClassName={cx(styles.parentContent, hasTitle ? '' : styles.radiusTop)}
      wrapperClassName={styles.DialogWrapper}
      contentParentClassName={cx(
        isNoButton ? styles.radiusBottom : '',
        isNoButton && hasTitle ? styles.resetRadiusBottom : '',
      )}
      buttonLabelPrimary={buttonLabelPrimary}
      buttonLabelSecondary={buttonLabelSecondary}
      actionButtonsClassName={cx(
        styles.actionButtons,
        isOneButton ? styles.oneButton : '',
        hasTitle ? styles.noTitleButtons : '',
      )}
      {...rest}
    />
  );
};

export default Dialog;
